/**
 * MonthPicker — choose a "YYYY-MM" month for the usage screens (SF-5095).
 *
 * The usage counts cover all history, so unlike the Eva period picker there is no launch floor:
 * it offers the last USAGE_MONTHS_BACK months, newest first (see usageMonthOptions).
 */
import { Select } from 'antd';
import { formatBucketLabel } from '../../utils/date';
import { usageMonthOptions } from './usageNumbers';

export interface MonthPickerProps {
  /** The chosen month, "YYYY-MM". */
  value: string;
  onChange: (period: string) => void;
  disabled?: boolean;
}

export const MonthPicker: React.FC<MonthPickerProps> = ({ value, onChange, disabled }) => (
  <Select
    aria-label="Month"
    value={value}
    onChange={onChange}
    disabled={disabled}
    options={usageMonthOptions().map((period) => ({
      value: period,
      label: formatBucketLabel(period, 'monthly'),
    }))}
    style={{ minWidth: 160 }}
  />
);
